/*
 * Name : page_about.js
 * Description: Motherhouse About Us Page Indivisual Script
 *
 * 1.
 *
 *
 */

/*--------------------------
	Block Story Logo Hover
--------------------------*/
window.addEventListener("DOMContentLoaded", () => {
  $(function () {
    var $banner = $(".js_story_banner, .js_company_banner");
    var $off = $banner.find(".off");
    var $on = $banner.find(".on");
    var duration = 400;

    if ($off.length > 0 && $on.length > 0) {
      var activate = function () {
        $off.stop().fadeOut(duration);
        $on.stop().fadeIn(duration);
      };
      var disactivate = function () {
        $on.stop().fadeOut(duration);
        $off.stop().fadeIn(duration);
      };

      $banner.on("mouseenter", activate);
      $banner.on("mouseleave", disactivate);
    }
  });
});
